import { ImageScaleView } from '@play-co/timestep-core/ui';
import { Avatar } from './Avatar';
import { AvatarFrameId } from 'src/replicant/profile/frames';
import { loader } from '@play-co/timestep-core';

const frameAssets: Record<Exclude<AvatarFrameId, 'default'>, string> = {
  league_crown: 'assets/ui/avatarFrames/avatar_frame_league_crown.png',
  league_master: 'assets/ui/avatarFrames/avatar_frame_league_master.png',
  league_grandmaster:
    'assets/ui/avatarFrames/avatar_frame_league_grandmaster.png',
  league_champion: 'assets/ui/avatarFrames/avatar_frame_league_champion.png',
};

type BasicAvatarFrameOpts = {
  avatar: Avatar;
  id?: AvatarFrameId;
};

const frameToAvatarRatio = 1.18;

export class BasicAvatarFrame extends ImageScaleView {
  private pendingFrameUpdate: string | null = null;

  constructor(opts: BasicAvatarFrameOpts) {
    const { avatar, id } = opts;
    const size = avatar.style.width * frameToAvatarRatio;

    super({
      superview: avatar,
      width: size,
      height: size,
      x: (avatar.style.width - size) / 2,
      y: (avatar.style.height - size) / 2,
      zIndex: 10,
    });

    // Set initial frame if provided
    if (id) {
      this.setFrame(id);
    }
  }

  public async setFrame(id: AvatarFrameId) {
    if (id === 'default') {
      this.updateOpts({ visible: false });
      return;
    }

    const asset = frameAssets[id];

    // Set current image update.
    this.pendingFrameUpdate = asset;

    // Preload image - if successful, it should return a valid descriptor
    const imageDesc = await loader.loadImage(asset);

    // Another update already happened or preload failed, bail out.
    if (this.pendingFrameUpdate !== asset || !imageDesc) return;

    this.updateOpts({
      visible: true,
      image: imageDesc,
    });
  }
}
